module.exports = __webpack_public_path__ + "static/media/samsungsharpsans-bold_1.68af5522.woff";